var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"pb_content",staticStyle:{"background":"#f0f2f5"}},[_c('div',{staticClass:"pb_content_body",staticStyle:{"position":"relative","margin":"0"}},[_c('div',{staticClass:"right"},[_c('div',{staticClass:"courseTop"},[_c('div',{staticClass:"stepsNav"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{
                path:
                  '/test?userid=' +
                  _vm.userid +
                  '&oid=' +
                  _vm.oid +
                  '&org=' +
                  _vm.org +
                  '&role=' +
                  _vm.role,
              }}},[_vm._v("表单管理")]),_vm._v(" "),(_vm.type == 3)?_c('el-breadcrumb-item',{attrs:{"to":{
                path:
                  '/checkToTest2?uid=' +
                  _vm.userid2 +
                  '&userid=' +
                  _vm.userid +
                  '&oid=' +
                  _vm.oid +
                  '&org=' +
                  _vm.org +
                  '&role=' +
                  _vm.role,
              }}},[_vm._v("\n              查看表单\n            ")]):_c('el-breadcrumb-item',{attrs:{"to":{
                path:
                  '/checkToTest?cid=' +
                  _vm.cid +
                  '&userid=' +
                  _vm.userid +
                  '&oid=' +
                  _vm.oid +
                  '&org=' +
                  _vm.org +
                  '&role=' +
                  _vm.role,
              }}},[_vm._v("\n              查看表单\n            ")]),_vm._v(" "),_c('el-breadcrumb-item',[_c('span',{staticStyle:{"color":"rgb(15, 126, 255)"}},[_vm._v(_vm._s(_vm.name))])])],1)],1),_vm._v(" "),_c('div',{staticClass:"r_pub_button_retrun",on:{"click":_vm.retrunCourse}},[_vm._v("返回")])]),_vm._v(" "),_c('div',{staticClass:"step_box"},[_c('div',{staticClass:"edit_top"},[_c('div',{staticClass:"op_btn"},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.publish}},[_vm._v("确定批改")])],1)]),_vm._v(" "),_c('topicVue',{ref:"topicVue",attrs:{"cJson":_vm.cJson,"title":_vm.title,"brief":_vm.brief,"checktype":2,"see":_vm.see,"isTeacher":1,"name":_vm.name}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1278582","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/test/check/check.vue
// module id = null
// module chunks = 